export const contentStyle = {
  background: '#ffffff',
  padding: '2rem',
  margin: 0,
  minHeight: 700
}

export const cardStyle = {
  height: '100%'
}

export const colStyle = {
  marginBottom: '1rem'
}

export const footerStyle = {
  backgroundColor: '#031529',
  color: 'white',
  textAlign: 'center'
}

export const iconStyle = {
  fontSize: '1.25rem',
  marginRight: '10px'
}

export const titleStyle = {
  marginTop: '3rem'
}

export const tableStyle = {
  overflowX: 'auto'
}
